// Material
import { styled } from '@mui/material/styles'
// component
import { List } from '@mui/material'
import {
  QuestionOutlinedIcon,
  ContactOutlinedIcon,
  BookmarkOutlinedIcon,
  SettingsOutlinedIcon,
  ExitToAppIcon,
  AddUserIcon,
  CallIcon,
  SupportChatIcon,
} from '@weblite/icons'
// Common
import { ProfileActionItem } from '$common/profile-action-item'
// Icons
// assets [icons]
// TODO: postfix all with Icon keyword
// Localization
import { t } from '$i18n'
import {
  openContacts,
  openContactUs,
  openFAQ,
  openInviteFriends,
  openSettings,
} from '$logic/router'
import { getPrivateSpace } from '$logic/private-space'
import { showLogoutModal } from '$comp/modals/confirmation-dialog'
import { openRoom } from '$logic/opened-room'
import { useCanInvite } from '$logic/invite/react-hook'
import { openSupport } from '$func/open-support'

const StyledList = styled(List)(({ theme }) => ({
  padding: 0,
  backgroundColor: theme.palette.white,
  borderRadius: 15,
  filter: 'drop-shadow(0px 0px 5px rgba(0, 0, 0, 0.1))',
}))

export function MyAccountActions() {
  const onSavedMessageClick = () => {
    openRoom(getPrivateSpace()?.roomId)
    analite('PROFILE_SAVED_CLICK')
  }
  const onSupportClick = async () => {
    openSupport()

    analite('PROFILE_SUPPORT_CLICK')
  }
  const canInvite = useCanInvite()

  const onContactsClick = () => {
    analite('PROFIE_CONTACTS_CLICK')
    openContacts()
  }

  const onInviteClick = () => {
    analite('PROFILE_INVITE_CLICK')
    openInviteFriends()
  }

  return (
    <>
      <StyledList>
        <ProfileActionItem
          Icon={<ContactOutlinedIcon />}
          onClick={onContactsClick}
        >
          {t('myAccount.contact')}
        </ProfileActionItem>

        <ProfileActionItem
          Icon={<BookmarkOutlinedIcon />}
          onClick={onSavedMessageClick}
        >
          {t('myAccount.savedMessage')}
        </ProfileActionItem>

        <ProfileActionItem
          Icon={<SettingsOutlinedIcon />}
          onClick={openSettings}
        >
          {t('common.settings')}
        </ProfileActionItem>
      </StyledList>

      <StyledList>
        <ProfileActionItem Icon={<SupportChatIcon />} onClick={onSupportClick}>
          {t('myAccount.support')}
        </ProfileActionItem>

        {import.meta.env.VITE_ENABLE_FAQ === 'true' && (
          <ProfileActionItem Icon={<QuestionOutlinedIcon />} onClick={openFAQ}>
            {t('myAccount.faq')}
          </ProfileActionItem>
        )}

        <ProfileActionItem Icon={<CallIcon />} onClick={openContactUs}>
          {t('myAccount.contactUs')}
        </ProfileActionItem>

        {canInvite && (
          <ProfileActionItem Icon={<AddUserIcon />} onClick={onInviteClick}>
            {t('myAccount.inviteFriends')}
          </ProfileActionItem>
        )}

        {/* <ProfileActionItem */}
        {/*  Icon={<RulesIcon />} */}
        {/*  onClick={onPrivacyPolicyClick} */}
        {/*  disabled */}
        {/* > */}
        {/*  {t('common.termsAndConditions')} */}
        {/* </ProfileActionItem> */}

        <ProfileActionItem Icon={<ExitToAppIcon />} onClick={showLogoutModal}>
          {t('myAccount.logout')}
        </ProfileActionItem>
      </StyledList>
    </>
  )
}
